export const isMobileDevice = () => {
    return window.cordova && (window.cordova as any).platformId !== 'browser';
};

export const isIosDevice = () => {
    return window.cordova && (window.cordova as any).platformId === 'ios';
};

export const hasConnectionForLogin = () => {
    if (isMobileDevice()) {
        return (<any>navigator).connection.type !== 'none';
    } else {
        return true;
    }
};